import { conversationLimitCutoff, isWithinConversationLimitGrace } from "../../supabase/functions/_shared/conversation-limit";

export type PaywallReason = "manual-block" | "authorization-lost" | "debt" | "overage" | null;

export interface PaywallOrgState {
  ai_active: boolean;
  manual_block: boolean;
  limit_exceeded_at: string | null;
  per_use_authorization_lost_at?: string | null;
}

/**
 * A manual block outranks everything else: it is a support decision, not a
 * payment state, so it never offers a Mercado Pago flow. Debt suspension is
 * driven by ai_active, which billing-charge and set-manual-block both flip.
 */
export function resolvePaywallReason(
  org: PaywallOrgState,
  now: number = Date.now(),
): PaywallReason {
  if (org.manual_block === true) return "manual-block";
  if (org.per_use_authorization_lost_at) return "authorization-lost";
  if (org.ai_active === false) return "debt";

  if (conversationLimitCutoff(org.limit_exceeded_at) && !isWithinConversationLimitGrace(org.limit_exceeded_at, new Date(now))) {
    return "overage";
  }

  return null;
}
